var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import { NewleadFieldsFragmentDoc } from './useUserNewLead.gql';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var New_Leads_By_Auth0_User_IdDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query new_leads_by_auth0_user_id($Auth0UserId: String!) {\n  new_leads(where: {user: {Auth0UserId: {_eq: $Auth0UserId}}}) {\n    ...newleadFields\n  }\n}\n    ", ""], ["\n    query new_leads_by_auth0_user_id($Auth0UserId: String!) {\n  new_leads(where: {user: {Auth0UserId: {_eq: $Auth0UserId}}}) {\n    ...newleadFields\n  }\n}\n    ", ""])), NewleadFieldsFragmentDoc);
/**
 * __useNew_Leads_By_Auth0_User_IdQuery__
 *
 * To run a query within a React component, call `useNew_Leads_By_Auth0_User_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNew_Leads_By_Auth0_User_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNew_Leads_By_Auth0_User_IdQuery({
 *   variables: {
 *      Auth0UserId: // value for 'Auth0UserId'
 *   },
 * });
 */
export function useNew_Leads_By_Auth0_User_IdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(New_Leads_By_Auth0_User_IdDocument, options);
}
export function useNew_Leads_By_Auth0_User_IdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(New_Leads_By_Auth0_User_IdDocument, options);
}
var templateObject_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQXV0aDBVc2VyTmV3TGVhZC5ncWwuanN4Iiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlQXV0aDBVc2VyTmV3TGVhZC5ncWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUVBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUNyQyxPQUFPLEVBQUUsd0JBQXdCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUNoRSxPQUFPLEtBQUssTUFBTSxNQUFNLGdCQUFnQixDQUFDO0FBQ3pDLElBQU0sY0FBYyxHQUFHLEVBQVcsQ0FBQztBQVNuQyxNQUFNLENBQUMsSUFBTSxrQ0FBa0MsR0FBRyxHQUFHLDhPQUFBLHVLQU0vQyxFQUF3QixFQUFFLEtBQTFCLHdCQUF3QixDQUFFLENBQUM7QUFFakM7Ozs7Ozs7Ozs7Ozs7OztHQWVHO0FBQ0gsTUFBTSxVQUFVLGtDQUFrQyxDQUFDLFdBQStHO0lBQzFKLElBQU0sT0FBTyx5QkFBTyxjQUFjLEdBQUssV0FBVyxDQUFDLENBQUE7SUFDbkQsT0FBTyxNQUFNLENBQUMsUUFBUSxDQUE0RSxrQ0FBa0MsRUFBRSxPQUFPLENBQUMsQ0FBQztBQUNqSixDQUFDO0FBQ1AsTUFBTSxVQUFVLHNDQUFzQyxDQUFDLFdBQW9IO0lBQ2pLLElBQU0sT0FBTyx5QkFBTyxjQUFjLEdBQUssV0FBVyxDQUFDLENBQUE7SUFDbkQsT0FBTyxNQUFNLENBQUMsWUFBWSxDQUE0RSxrQ0FBa0MsRUFBRSxPQUFPLENBQUMsQ0FBQztBQUNySixDQUFDIn0=